import * as React from "react";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Theme from "../Theme";
import Styled from "styled-components";
import { withRouter, RouteComponentProps } from "react-router-dom";
import TabInfos from "../models/TabInfos";
import { connect } from "react-redux";
import { IApplicationState } from "../store";
import { selectAuth } from "../store/auth/selectors";
import getLocationInfo from "../functions/getLocationInfo";
import { userInRoles } from "./api-authorization/AuthorizeRoute";
import Roles from "../models/Roles";

const StyledTabs = Styled(Tabs)`
    min-height: 0;
    padding: 0 20px;

    & .MuiTabs-indicator {
        background-color: ${Theme.colors.accentWarmLight};
        height: 6px;
    }
`;

const StyledTab = Styled(Tab)`
    font-family: ${Theme.fonts.header};
    font-size: 18px;
    font-weight: bold;
    color: ${Theme.colors.white};

    &&& {
      opacity: 1;
      text-transform: none;
      padding: 0 0 3px 0;
      min-width: 0;
      min-height: 0;
      margin: 0 50px 0 0;
    }

    & .MuiTab-wrapper:hover {
        height: 25px;
        border-bottom: 6px solid ${Theme.colors.darkBackgroundHover};
        margin-bottom: -6px;
    }
`;

const DefaultTab = Styled(Tab)`
    display: none;
`;

export interface ITabMenuProps extends RouteComponentProps {
  isAuthenticated: boolean;
  userRoles: string[];
}

const TabMenu = (props: ITabMenuProps) => {
  const { history, location, isAuthenticated, userRoles } = props;

  const getCurrentRoute = () => {
    return getLocationInfo(location).tab;
  };

  const handleChange = (event: any, value: any) => {
    history.push(value);
  };

  let value = getCurrentRoute();
  if (!TabInfos.filter(t => t.route === value).length) {
    value = "default";
  }

  return (
    <>
      <StyledTabs value={value} onChange={handleChange} centered>
        <DefaultTab label="Default" value="default" />
        {TabInfos.map(
          tab => (userInRoles(tab.includedRoles, userRoles) || !isAuthenticated) && <StyledTab key={tab.label} label={tab.label} value={tab.route} />,
        )}
      </StyledTabs>
    </>
  );
};

const TabMenuWithRouter = withRouter(TabMenu);
export default connect((state: IApplicationState) => ({
  ...selectAuth(state),
}))(TabMenuWithRouter);
